exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.navbar-wrapper[data-v-480f6fb6] {\n  background: #ffffff;\n  -webkit-box-shadow: 0px 1px 2px rgba(30, 27, 34, 0.1);\n          box-shadow: 0px 1px 2px rgba(30, 27, 34, 0.1);\n  /* position: fixed; */\n}\n", ""]);

// exports
